export default __webpack_public_path__ + "static/media/DSCF1602.58cf896d.jpg";